(() => {
  const initializeFooter = (footer) => {
    if (!footer || footer.dataset.particlesReady === 'true') {
      return;
    }

    const particles = footer.querySelectorAll(
      '[data-footer-particles] .premium-footer__particle'
    );

    particles.forEach((particle, index) => {
      const left = 3 + Math.random() * 94;
      const size = 2 + Math.random() * 3;
      const duration = 17 + Math.random() * 14;
      const delay = -(Math.random() * duration);
      const drift = -22 + Math.random() * 44;

      particle.style.setProperty('--particle-left', `${left}%`);
      particle.style.setProperty('--particle-size', `${size}px`);
      particle.style.setProperty('--particle-duration', `${duration}s`);
      particle.style.setProperty('--particle-delay', `${delay}s`);
      particle.style.setProperty('--particle-drift', `${drift}px`);

      particle.setAttribute('data-particle', String(index + 1));
    });

    footer.dataset.particlesReady = 'true';
  };

  const initializeAllFooters = (root = document) => {
    root
      .querySelectorAll('[data-premium-footer]')
      .forEach(initializeFooter);
  };

  document.addEventListener('DOMContentLoaded', () => {
    initializeAllFooters();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllFooters(event.target);
  });
})();